import { gql } from 'apollo-boost';

export const GetActivePopups = gql`
query GetActivePopups {
  activePopups {
    results {
      id
      title
      body
      imageUrl
      notificationType
      priority
      startDate
      endDate
      ctaLink
      ctaText
      isClosable
      targetLocation: target_paths
    }
  }
}
`;
